import { Box, Button, InputLabel, TextField, Typography } from '@mui/material';
import Helmet from 'react-helmet';
import seo from '../../assets/img/seo2.svg';
import SocialTags from '../SocialTags';

type Props = {
  title: string;
  description?: string;
  url: string;
  keywords?: string;
  setUrl: React.Dispatch<React.SetStateAction<string>>;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  error: boolean;
  setError?: React.Dispatch<React.SetStateAction<boolean>>;
};
const ReusableSeo = ({ title, description, url, keywords, setUrl, handleSubmit, error }: Props) => {
  return (
    <>
      <Helmet>
        <title>
          ReachAI - Business Automation. Build Leads, Get digital powered websites and marketing
          your businesses - {keywords}
        </title>
        <meta
          name="description"
          content="Welcome to ReachAI. Build Leads, Get digital powered websites and marketing your businesses "></meta>
        <meta
          name="keywords"
          content="website development in Cypress, website development in Houston, SEO,website development in Texas,website development near Cypress, website development near 77429, mobile app development near Cypress, android app development near Cypress, ios app development near Cypress, software development, custom software, software solutions, software company, software development company, software developer, software development services, software development agency, software development firm, Digital powered websites, marketing my businesses, reachai, Digital powered websites, marketing my businesses, reachai, ESSL"
        />
        <SocialTags />
      </Helmet>
      <Box sx={styles.main}>
        <Box sx={styles.body}>
          <Box sx={styles.container}>
            <Box sx={styles.left}>
              <Typography variant="h3" mb={'20px'}>
                {title} with <br /> ReachAI.
              </Typography>
              {error && (
                <Typography variant="subtitle1" color="red">
                  Please enter a valid URL
                </Typography>
              )}
              <form onSubmit={handleSubmit}>
                <Box sx={styles.formStyle}>
                  <InputLabel htmlFor="url">Website URL</InputLabel>
                  <TextField
                    type="text"
                    placeholder="Enter your website URL"
                    sx={styles.inputStyle}
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                  />

                  <Button fullWidth variant="contained" type="submit" sx={styles.buttonStyle}>
                    Search
                  </Button>
                </Box>
              </form>
              <Typography variant="h6" my={'20px'}>
                {description ||
                  `Boost Your Online Visibility with SEO Expertise: Examine your website's Search Engine Optimization and look for ways to improve it.`}
              </Typography>
            </Box>
            <Box sx={styles.right}>
              <img src={seo} alt="hero" width={500} height={500} />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ReusableSeo;
const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh'
  },
  body: {
    flexGrow: 1,
    maxWidth: '1290px',
    mx: 'auto',
    width: { xs: '90%', lg: '100%' },
    px: 2
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    my: '50px'
  },
  button: {
    backgroundColor: '#FF6854 !important',
    color: '#fff',
    px: 3,
    borderRadius: 10,
    textTransform: 'capitalize',
    mb: '20px'
  },
  left: {
    maxWidth: '600px'
  },
  right: {
    display: { sm: 'none', md: 'block' },
    maxWidth: '500px'
  },
  formStyle: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  inputStyle: {
    fontSize: '16px',
    flex: '1',
    width: '100%',
    py: 1
  },
  buttonStyle: {
    fontSize: '16px',
    border: 'none',
    mt: 3,
    cursor: 'pointer'
  }
};
